import {
  Component,
  ChangeDetectionStrategy,
  Input,
  ContentChild,
  ViewChild,
  ElementRef,
  SimpleChanges,
  OnChanges,
  ViewEncapsulation,
} from '@angular/core';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-mat-spinner-button',
  templateUrl: './mat-spinner-button.component.html',
  styleUrls: ['./mat-spinner-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class MatSpinnerButtonComponent implements OnChanges {
  @ViewChild('spinnerRef', { static: true, read: ElementRef })
  loadingSpinnerElement: ElementRef;

  @ContentChild(MatButton, { static: true, read: ElementRef })
  materialButtonElement: ElementRef;

  @ContentChild(MatButton, { static: true }) materialButtonInstance: MatButton;

  @Input() loading: boolean;

  ngOnChanges(changes: SimpleChanges): void {
    if ('loading' in changes) {
      this.materialButtonInstance.disabled = !!this.loading;
    }
  }
}
